import { render } from "./AddMonitorTargetDialog.vue?vue&type=template&id=2ab57045&scoped=true"
import script from "./AddMonitorTargetDialog.vue?vue&type=script&lang=js"
export * from "./AddMonitorTargetDialog.vue?vue&type=script&lang=js"

import "./AddMonitorTargetDialog.vue?vue&type=style&index=0&id=2ab57045&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab57045"],['__file',"src/containers/performance/AddMonitorTargetDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ab57045"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ab57045', __exports__)) {
    api.reload('2ab57045', __exports__)
  }
  
  module.hot.accept("./AddMonitorTargetDialog.vue?vue&type=template&id=2ab57045&scoped=true", () => {
    api.rerender('2ab57045', render)
  })

}


export default __exports__